import { render, staticRenderFns } from "./Toggles.vue?vue&type=template&id=61e47e1d&scoped=true"
import script from "./Toggles.vue?vue&type=script&lang=js"
export * from "./Toggles.vue?vue&type=script&lang=js"
import style0 from "./Toggles.vue?vue&type=style&index=0&id=61e47e1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e47e1d",
  null
  
)

export default component.exports